import { render, staticRenderFns } from "./SecurityPolicies.vue?vue&type=template&id=3498f14c&"
import script from "./SecurityPolicies.vue?vue&type=script&lang=ts&"
export * from "./SecurityPolicies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports